import { Injectable } from "@angular/core";
import { Headers, Http, RequestMethod, RequestOptions, Response } from "@angular/http";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Rx";
import { ApiUrlConstants } from "../../common/constants/api.constants";
import { AccessLevel } from "../../common/enums/access-level.enum";
import { TicketType } from "../interface/ticket-type";
import { Permission } from "../models/permission";
import { PermissionGroup } from "../models/permission-group";
import { Role } from "../models/role";
import { User } from "../models/user";
import { environment } from "./../../../environments/environment";
import { EmailConfiguration } from "../interface/emailConfiguration";
@Injectable()
export class DepartmentService {
    headers: Headers;
    options: RequestOptions;
    source: string = "AS400";

    constructor(private _http: Http) {
        this.headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'q=0.8;application/json;q=0.9'
        });
        this.options = new RequestOptions({ headers: this.headers });
    }

    private customerServiceURL = ApiUrlConstants.customerServiceApiUrl;
    /**
       * To handle the obervable error response
       * @param  {Response|any} error
       */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error);
    };



    getTicketTypesAndSubTypes(operatingCountryId?: number): Observable<TicketType[]> {
        let url = ApiUrlConstants.customerServiceApiUrl + "types/sub-types";
        if (operatingCountryId) {
            url = url + "?operatingCountryId=" + operatingCountryId;
        }
        return this._http.get(decodeURIComponent(encodeURIComponent(url)))
            .map((res: Response) => <TicketType[]>res.json())
            .catch((error: any) =>
                Observable.throw(error.json().error || "server error")
            );
    }

    saveDepartment(department: any){
        return this._http.post(this.customerServiceURL + "/departments", department)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    updateDepartment(department: any){
        let headers = new Headers();
        headers.append('Department', department.id.toString());
        let options = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        return this._http.put(this.customerServiceURL + "/departments/"+department.id, department,options)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    getTicketTypes() {
        let getUrl = ApiUrlConstants.customerServiceApiUrl + "ticket-types";
        return this._http.get(getUrl)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    getSubTypes(ticketTypeId: number) {
        let getUrl = ApiUrlConstants.customerServiceApiUrl + "ticket-subtypes/" + ticketTypeId;
        return this._http.get(decodeURIComponent(encodeURIComponent(getUrl)))
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }



    getDepartmentTicketsStatus(departmentId:any){
        let getUrl = ApiUrlConstants.customerServiceApiUrl + "departments/" + departmentId+"/tickets-exist";
        return this._http.get(getUrl)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

      deactivateDepartment(id:number,status:Boolean){
          let headers = new Headers();
        headers.append('Department', id.toString());
        let options = new RequestOptions({ method: RequestMethod.Patch, headers: headers });
        let getUrl = ApiUrlConstants.customerServiceApiUrl + "departments/" + id+"?active="+status;
        return this._http.patch(getUrl,{},options)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }


    
    /**
 * To get list of users based on search request
 * @param  {USER} user object as body
 * @returns Observable
 */

    searchUsersWithPagination(departmentId: any, userName?: String, firstName?: String, lastName?: String, roleIds?: any, loggedinUserId?: number,
        pageSize?: number, pageNumber?: number, isDesc?: boolean, sortColumn?: string): Observable<any[]> {
        let url = ApiUrlConstants.enrollmentApigwUrl + "departments/" + departmentId + "/users";
        let count = 0;

        if (userName != null && userName != undefined) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + "userName=" + userName.trim();
            count++;
        }
        if (firstName!= null && firstName != undefined) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + "firstName=" + firstName.trim();
            count++;
        }
        if (lastName!= null && lastName != undefined) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + "lastName=" + lastName.trim();
            count++;
        }
        if (roleIds!= null && roleIds != undefined) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + "roleIds=" + roleIds;
            count++;
        }
        if (loggedinUserId != null) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + "loggedinUserId=" + loggedinUserId;
            count++;
        }

        if (pageSize > 0) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + "pageSize=" + pageSize;
            count++;
        }

        if (pageNumber > 0) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + "pageNumber=" + pageNumber;
            count++;
        }

        if (isDesc != null && isDesc != undefined) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + 'sort=' + (isDesc ? 'DESC' : 'ASC');
            count++;
        }

        if (sortColumn != null && sortColumn != undefined) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + 'elements=' + sortColumn;
            count++;
        }

        let headers = new Headers();
        headers.append('Department', departmentId);
        let options = new RequestOptions({ method: RequestMethod.Get, headers: headers });

        return this._http
            .get(url)
            .map((res: Response) => res.json())
            .catch((error: any) =>
                Observable.throw(error.json().error || "server error")
            );
    }

    getDepartments(pageNumber: number, pageSize: number, sortColumn: string, isDesc: boolean, name?: string, operatingCountryId?: number): Observable<any> {
        
        let url = ApiUrlConstants.customerServiceApiUrl + "departments?pageNumber=" + pageNumber + "&pageSize=" + pageSize;
 
        if (name && name.trim().length > 0) {
            url = url + "&name=" + name.trim();
        }
        if (operatingCountryId && operatingCountryId > 0) {
            url = url + "&operatingCountryId=" + operatingCountryId;
        }
        if (isDesc != null && isDesc != undefined) {
            url = url + '&sort=' + (isDesc ? 'ASC' : 'DESC');
        }
        if (sortColumn != null && sortColumn != undefined) {
            url = url + '&sortOrder=' + sortColumn;
        }
        return this._http.get(url)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }


  getOperatingCountries() {       
        return this._http.get(environment.apiUrl +"/admin/V1/countries").map((res: Response) => res.json()).catch((error: any) =>
            Observable.throw(error.json().error || "server error")
        );
    }   

    getDepartmentById(departmentId: any) {
         let headers = new Headers();
        headers.append('Department', departmentId.toString());
        let options = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        let getUrl = ApiUrlConstants.customerServiceApiUrl + "departments/"+departmentId;
        return this._http.get(getUrl,options)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
* To get list users.
* @param storeId
* @returns Observable
*/
    getUnassignedUsersToDepartment(departmentId: any) {
        let headers = new Headers();
        headers.append('Department', departmentId);
        let options = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        return this._http.get(ApiUrlConstants.enrollmentApigwUrl + "departments/" + departmentId + "/unassigned-users").map((res: Response) => <User[]>res.json()).catch((error: any) =>
            Observable.throw(error.json().error || "server error")
        );
    }

    /**
    * To assign a user to specific department
    * @param {User}
    * @returns Observable
    */
    assignUser(user: any) {
        let body = JSON.stringify(user);
        let headers = new Headers();
        headers.append('Department', user.departmentId);
        let options = new RequestOptions({ method: RequestMethod.Post, headers: headers });
        return this._http.post(ApiUrlConstants.enrollmentApigwUrl + "departments/" + user.departmentId + "/users/" + user.id, body,options).map(res => { return res.json() }).catch((error: any) =>
            Observable.throw(error || "server error")
        );

    }

    /**
    * To un-assign a user to specific department
    * @param {User}
    * @returns Observable
    */
    unassignUser(departmentId: Number,userId:Number) {
       
        let headers = new Headers();
        headers.append('Department', departmentId.toString());
        let options = new RequestOptions({ method: RequestMethod.Delete, headers: headers });
        return this._http.delete(ApiUrlConstants.enrollmentApigwUrl + "departments/" + departmentId + "/users/" + userId,options).map(res => { return res.json() }).catch((error: any) =>
            Observable.throw(error || "server error")
        );

    }

    /**
* To get list of roles and permissions
* @param empty
* @returns Observable
*/
    getUserById(departmentId: any, userId: any) {
        let headers = new Headers();
        headers.append('Department', departmentId);
        let options = new RequestOptions({ method: RequestMethod.Get, headers: headers });
        return this._http.get(ApiUrlConstants.enrollmentApigwUrl + "departments/" + departmentId + "/users/" + userId,options).map((res: Response) => <User[]>res.json()).catch((error: any) =>
            Observable.throw(error.json().error || "server error")
        );

    }

    /**
  * To get list of store level custom roles 
  * @param empty
  * @returns Observable
  */
    getRoles() {
        return this._http.get(environment.accountThroughGateway + "role-levels/" + AccessLevel.Department + "/custom-roles?roleType=Custom Role").map((res: Response) => <Role[]>res.json()).catch((error: any) =>
            Observable.throw(error.json().error || "server error")
        );
    }

    updateUser(user: any) {
        let body = JSON.stringify(user);
        let headers = new Headers();
        headers.append('Department', user.departmentId);
        let options = new RequestOptions({ method: RequestMethod.Put, headers: headers });
        return this._http.put(ApiUrlConstants.enrollmentApigwUrl + "departments/" + user.departmentId + "/users/" + user.userId, user,options).map(res => { return res.json() }).catch((error: any) =>
            Observable.throw(error || "server error")
        );
    }

    getUserTicketsStatusForDepartment(departmentId:Number,userId:Number){
        let getUrl = ApiUrlConstants.customerServiceApiUrl + "departments/" + departmentId+"/tickets-exist?userId="+userId;
        return this._http.get(getUrl)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

      /**
    * To get tole by id 
    * @param  role id
    * @returns role object
    */
    getPermissionsByRoleIds(roleIds: number[]): Observable<Permission[]> {

        let _url = environment.accountThroughGateway + "role-permissions?roleIds="+roleIds;
        return this._http.get(_url).map((res: Response) => <Permission[]>res.json()).catch((error: any) =>
            Observable.throw(error.json().error || "server error")
        );
    }
      /**
* To get list of permissions 
* @param roleLevelIds
* @returns Observable
*/
    getPermissionsByAccessLevelIds(roleLevelIds:number[]) {

        return this._http.get(environment.accountThroughGateway + "permissions?accessLevelIds=" + roleLevelIds).map((res: Response) => <PermissionGroup[]>res.json()).catch((error: any) =>
            Observable.throw(error.json().error || "server error")
        );
    }

   /**
 * To get list of unassigend users based on search request
 * @param  {USER} user object as body
 * @returns Observable
 */

  getUnAssignedUsersByDeaprtmentd(departmentId: any, firstName?: String, lastName?: String, email?:string, phoneNumber?:String,
                    loginId?: String,pageSize?: number, pageNumber?: number, isDesc?: boolean, sortColumn?: string): Observable<any[]> {
        let url = ApiUrlConstants.enrollmentApigwUrl + "departments/" + departmentId + "/unassigned-users/search";
        let count = 0;
       
        if (firstName.length > 0) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + "firstName=" + firstName.trim();
            count++;
        }
        if (lastName.length > 0) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + "lastName=" + lastName.trim();
            count++;
        } 

         if (phoneNumber.length > 0) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + "phoneNumber=" + phoneNumber.trim();
            count++;
        }

         if (email.length > 0) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + "email=" + email.trim();
            count++;
        }
       
        if (loginId.length > 0) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + "userName=" + loginId.trim();
            count++;
        }

        if (pageSize > 0) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + "pageSize=" + pageSize;
            count++;
        }

        if (pageNumber > 0) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + "pageNumber=" + pageNumber;
            count++;
        }

        if (isDesc != null && isDesc != undefined) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + 'sort=' + (isDesc ? 'DESC' : 'ASC');
            count++;
        }

        if (sortColumn != null && sortColumn != undefined) {
            url = url + ((count == 0) ? "?" : "&");
            url = url + 'sortOrder=' + sortColumn;
            count++;
        }
             
         return this._http.get(url).map((res: Response) => <User[]>res.json()).catch((error: any) =>
            Observable.throw(error.json().error || "server error")
        );      
    }

    getDepartmentsdataByOperatingCountryId(operatingCountryId) {
        const url = ApiUrlConstants.customerServiceApiUrl + 'operating-countries/' + operatingCountryId + '/departments';

      return this._http.get(decodeURIComponent(encodeURIComponent(url)))
      .map((res: Response) => res.json())
      .catch(this.handleErrorObservable);
    }

    /**
    * save emailConfiguration
    * @returns Observable
     */
    saveEmailConfig(emailConfigValue: EmailConfiguration): Observable<any> {
        const body = JSON.stringify(emailConfigValue);
        const url = this.customerServiceURL + 'departments/email-configuration';
        return this._http
            .post(url, body)
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }
    /**
    * update department whitelisting flag
    * @returns Observable
     */
     whitelistDepartmentEmail(emailId: string, uuid: string, departmentId: number): Observable<any> {
        const requestUrl = this.customerServiceURL + 'departments/'+departmentId+'/whitelist-email?emailId='+encodeURIComponent(emailId)+'&uuid='+uuid;
              return this._http
                .get(requestUrl)
                .map((res: Response) => res.json())
                .catch(this.handleErrorObservable);
    }
}


// WEBPACK FOOTER //
// ./src/app/customerservice/services/department.service.ts